var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSource = function SvgSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.999 12H6.998a4.002 4.002 0 0 1-4.002-4.002v0a4.002 4.002 0 0 1 4.002-4.001h2M14 3.997h2a4.002 4.002 0 0 1 4.003 4.001v0M6.996 7.998H15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.002,
    cy: 15.001,
    r: 4.002
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 20.004 2.173-2.173"
  }))));
};
export { SvgSource as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDY2ZjQ0Yjg4NGE4MjBlNDE0YjZjZDMyYTdkYmI0NGQuc3ZnIjs=";